<h1 style="text-align: center;">FCiR25 - Financial Cryptography in Rome 2025</h1>
<br>
<p style="text-align: center;">
  <b>First international conference: Financial Cryptography in Rome.</b> <br>
  October 1st, 2025 <br>
  Centro Convegni "Carlo A. Ciampi", Via Nazionale 190, Rome (Italy)
</p>
<div class="toptext">
  <h2>Organisers</h2>
  <p>
    Jointly organised by <b>Bank of Italy</b> (Banca d'Italia) and <b>De Cifris Association</b> (De Cifris APS).
  </p>
</div>
<div class="toptext">
  <h2>Chairs</h2>
  <p>
    <b></b>
    <em>
      Michela Iezzi (Bank of Italy)
      <br>
      Massimiliano Sala (De Cifris Association, Italy)
    </em>
  </p>
</div>
<div class="toptext">
  <h2>Invited Speaker</h2>
  <p>
    <b>Nigel Smart</b> (KU Leuven, Belgium and Zama, France)
    <br>
    <i>Cloud Encryption and Blockchain: a primer on TFHE and FHEVM</i>
  </p>
</div>

<div class="toptext" id="description">
  <h2>Description</h2>
  <p>
    Building on <a routerLink='/cifris24/fcir24'>our first event</a>, <b>Financial Cryptography in Rome</b> (FCiR25)
    covers all aspects of securing transactions and
    digital
    value, with a specific focus on commercial and currency contexts. While we host cryptographic talks on both
    fundamental research and real-world applications, we also encourage interdisciplinary works not strictly related
    to cryptography. <br>
    For more information, contact us at
    <a href="mailto:fcir25@decifris.it">
      fcir25&#64;decifris.it
    </a>
  </p>
  <p>
    The event will be streamed live at the following link: <a href="https://bancaditalia.webex.com/bancaditalia/j.php?MTID=m19c144ee293e17d99f9745414efc2508">webex</a>. Webinar number: 2376 638 9615. Pass: MSgM9Rfxk63.
  </p>
</div>

<div class="toptext" id="program">
  <h2>Program</h2>
  <p>
    The <a href="https://drive.google.com/file/d/1hyqMjy59zU8XPqIxDKFBquT6nsi7a644">pre-proceedings (draft)</a> are now
    available.
  </p>
  <table style="margin: auto; border-collapse: collapse; width: 95%; text-align: left;">
    <!-- FIRST SESSION -->
    <tr>
      <td colspan="2" style="padding: 6px; font-style: italic; text-align: center;">FIRST SESSION</td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold; width: 120px;">08:30 - 09:00</td>
      <td style="padding: 6px;">Registration</td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">09:00 - 09:15</td>
      <td style="padding: 6px;">Welcome address by <em>Giuseppe Zingrillo (Banca d’Italia)</em></td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">09:15 - 09:30</td>
      <td style="padding: 6px;">Welcome address by <em>Massimiliano Sala (De Cifris)</em></td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">09:30 - 10:00</td>
      <td style="padding: 6px;">
        Balancing Privacy and Regulation in the Design of Future Digital Payment Systems<br>
        <em>Matteo Nardelli, Francesco De Sclavis, Michela Iezzi</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">10:00 - 10:40</td>
      <td style="padding: 6px;">
        Invited Tutorial: Achieving Digital Self-Custody<br>
        <em>Geoffrey Goodell</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">10:40 - 11:00</td>
      <td style="padding: 6px;">Coffee Break</td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">11:00 - 12:00</td>
      <td style="padding: 6px;">
        Invited Tutorial: Cryptographic algorithms and protocols for financial data analysis<br>
        <em>Marco Pedicini &amp; Carla Mascia</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">12:00 - 13:00</td>
      <td style="padding: 6px;">
        Invited Talk: Cloud Encryption and Blockchain: a primer on TFHE and FHEVM<br>
        <em>Nigel Smart</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">13:00 - 14:00</td>
      <td style="padding: 6px;">Lunch</td>
    </tr>

    <tr>
      <td colspan="2" style="padding: 6px; font-style: italic; text-align: center;">SCIENTIFIC SESSION I</td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">14:00 - 14:20</td>
      <td style="padding: 6px;">
        SwissLedger and the Finternet Vision: The Path for a Unified Financial Ecosystem<br>
        <em>Lorenzo Barisone, Robert Bregy, Gianluca Perletti</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">14:20 - 14:40</td>
      <td style="padding: 6px;">
        Approaches to MEV in DAG-based DLTs<br>
        <em>Giulio Jan Valentini, Carla Mascia, Andrea Bracciali</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">14:40 - 15:00</td>
      <td style="padding: 6px;">
        Cross-primitive comparison in CP-ABE: Bilinear Pairing vs. Lattices<br>
        <em>Lorenzo Gasparini, Elia Onofri, Martina Palmucci, Marco Pedicini</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">15:00 - 15:20</td>
      <td style="padding: 6px;">
        Designs, Efficiency and Decentralised Applications of Threshold Schnorr Signatures<br>
        <em>Murat Cenk, Leonardo Errati, Alessio Meneghetti</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">15:20 - 15:40</td>
      <td style="padding: 6px;">
        Analysis of collision probability in Merkle trees in the Random Oracle Model<br>
        <em>Alessandro Corsi, Abdulla Almenhali, Nicola Laurenti</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">15:40 - 16:00</td>
      <td style="padding: 6px;">Coffee Break</td>
    </tr>
    <tr>
      <td colspan="2" style="padding: 6px; font-style: italic; text-align: center;">SCIENTIFIC SESSION II</td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:00 - 16:10</td>
      <td style="padding: 6px;">
        Regulation (EU) 2023/1114 (MiCAR), in light of the division of responsibilities established by Legislative
        Decree no. 129/2024 between the Bank of Italy and the Italian Companies and Stock Exchange Commission<br>
        <em>Ruggiero Morella</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:10 - 16:20</td>
      <td style="padding: 6px;">
        Credential Loss Problem for Cryptowallet Custodians<br>
        <em>Carlo Brunetta, Michele Battagliola</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:20 - 16:30</td>
      <td style="padding: 6px;">
        Empirical Evidence of Spillover Effects Between Bank and Crypto Market Bubbles<br>
        <em>Caterina Di Tommaso, Matteo Foglia, Vincenzo Pacelli</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:30 - 16:40</td>
      <td style="padding: 6px;">
        A practical encrypted Cloud for financial data<br>
        <em>Andrea Gelpi, Marco Marchesin</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:40 - 16:50</td>
      <td style="padding: 6px;">
        Rayls II: Fast, Private, and Compliant CBDCs<br>
        <em>Mario Yaksetig, Stephen Yang, Mahdi Nejadgholi, Pedro Pereira, Jiayu Xu</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">16:50 - 17:00</td>
      <td style="padding: 6px;">
        Classification of Attribute-Based Encryption Schemes Based on Access Policy Contents<br>
        <em>Mahdi Mahdavi, Helena Rifà-Pous, Zahra Ahmadian</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">17:00 - 17:10</td>
      <td style="padding: 6px;">
        Decentralization: A Qualitative Survey of Node Operators<br>
        <em>Alexander Lynham, Geoffrey Goodell</em>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: top;padding: 6px; font-weight: bold;">17:10 - 17:20</td>
      <td style="padding: 6px;">
        How to (not) use symmetric polynomials for digital signature<br>
        <em>Francesco Romeo, Antonio Corbo Esposito, Rosa Fera</em>
      </td>
    </tr>
  </table>
</div>

<div class="toptext" id="publications">
  <h2>Publications</h2>

  Talks presented at the conference FCiR25 will be published in two venues:
  <ul>
    <li><a href="https://drive.google.com/file/d/1hyqMjy59zU8XPqIxDKFBquT6nsi7a644">pre-proceedings</a> </li>
    <li>a special issue of <a href="https://www.degruyterbrill.com/journal/key/jmc/html?lang=en">Journal of Mathematical
        Cryptology </a> </li>
    <li>a volume of <a href="https://www.decifris.it/koine">De Cifris Koine</a> </li>

  </ul>

</div>

<div class="toptext" id="call">
  <h2>Call for papers</h2>
  <h3>Important deadlines</h3>
  <table class="timeline" style="margin: auto;">
    <tr>
      <td class="left-column">Submission deadline</td>
      <td class="right-column">May 28th, 2025</td>
    </tr>
    <tr>
      <td class="left-column">Acceptance notification</td>
      <td class="right-column">July 1st, 2025</td>
    </tr>
    <tr>
      <td class="left-column">Final papers</td>
      <td class="right-column">September 1st, 2025</td>
    </tr>
    <tr>
      <td class="left-column">Conference starts</td>
      <td class="right-column">October 1st, 2025</td>
    </tr>
  </table>
  <h3>Submission criteria</h3>
  <div>
    Conference contributions will be submitted <a href="https://easychair.org/conferences/?conf=fcir25">via
      EasyChair</a>.
    Papers must be formatted using the standard LNCS format and submitted as PDF files. Submissions
    in any other format will not be accepted.
    <br>
    <br>
  </div>
  <div>
    Submissions should not substantially overlap with work that has already been accepted for publication
    in any other peer-reviewed conference, workshop, journal, or proceedings. We consider simultaneous double
    submission
    to be a
    serious violation of research ethics and will treat it accordingly. However, it is acceptable for papers to be
    made
    available in non-peer-reviewed formats, such as technical reports or online preprint archives like ePrint.
    <br>
    <br>
  </div>
  <div>
    Authors are required, when submitting, to disclose any conflicts of interest with: program committee members,
    management of Bank of Italy, management of De Cifris when submitting their
    work.
    <br>
  </div>
  <h3>Accepted topics</h3>
  <div>
    <b>Blockchain & Distributed Systems</b>
    <ul>
      <li>Decentralized digital currencies and payment systems</li>
      <li>Decentralized finance (DeFi)</li>
      <li>Distributed consensus mechanisms</li>
      <li>Security and protocols for blockchain-based systems</li>
      <li>Smart contracts</li>
    </ul>
    <b>Compliance, Auditing & Certification</b>
    <ul>
      <li>Certification systems and audit trails for secure systems</li>
      <li>Forensics and transaction graph analysis for fraud prevention</li>
      <li>Regulatory issues of blockchain, cryptocurrencies, and digital payments</li>
    </ul>
    <b>Cryptography & Authentication</b>
    <ul>
      <li>Applied cryptography and secure communication protocols</li>
      <li>Authentication methods, identity management, and biometrics</li>
      <li>Functional encryption</li>
      <li>Homomorphic encryption</li>
      <li>Secure smartcards, tokens, and hardware-based security</li>
      <li>Transition to post-quantum and quantum-safe cryptography</li>
      <li>Zero-knowledge proofs</li>
    </ul>
    <b>Financial Systems & Economics</b>
    <ul>
      <li>Digital cash systems and electronic payment platforms</li>
      <li>Economic models and monetary aspects of cryptocurrencies</li>
      <li>Incentive mechanisms and game theory for blockchain</li>
      <li>Security in banking, financial services, and e-commerce</li>
    </ul>
    <b>Security & Privacy</b>
    <ul>
      <li>Access control and authorization systems</li>
      <li>Anonymity technologies and privacy protection</li>
      <li>Forensics, transaction analysis, and monitoring</li>
      <li>Fraud detection and social engineering</li>
      <li>Security and privacy in economics</li>
      <li>Security of mobile payments</li>
      <li>Security of online payments</li>
      <li>Security of peer-to-peer systems and decentralized networks</li>
    </ul>
    <b>Security in the Cloud</b>
    <ul>
      <li>Cloud computing, data outsourcing, and security challenges</li>
      <li>Network security and distributed system vulnerabilities</li>
      <li>Security in trusted execution environments (TEEs)</li>
    </ul>
  </div>
  <h3>Review criteria</h3>
  <div>
    <b>Regular Research Papers</b> should present original, unpublished scientific contributions to the field and
    will
    undergo a thorough
    peer review process. Submissions must adhere to the LNCS format and are
    limited to 15 pages, excluding references and appendices. Committee members are not required to review the
    appendices, so papers should be understandable without
    them.
    <br>
    <br>
  </div>
  <div>
    <b>Short Papers</b> will also undergo peer review, and will be evaluated based on their novelty
    and
    potential to inspire participant interest and future research directions. Short papers must not exceed 8 pages
    in
    the
    LNCS format, excluding references. The title of short papers must begin with "Short Paper:". Accepted short
    papers
    will
    be included in the conference proceedings.
    <br>
    <br>
  </div>
  <h3>Program committee</h3>
  <ul>
    <li> Marco Benedetti (Banca d'Italia - Italy) </li>
    <li> Andrea Bracciali (Università di Torino - Italy) </li>
    <li> Marco Calderini (University of Trento - Italy) </li>
    <li> Matteo Campanelli (Offchain Labs - USA)</li>
    <li> Claude Carlet (Univ. of Paris 8 - France and Univ. of Bergen - Norway) </li>
    <li> Murat Cenk (Ripple - Canada)</li>
    <li> Maria Christofi (BNP Paribas - France) </li>
    <li> Michele Ciampi (University of Edinburgh - Scotland) </li>
    <li> Roberto Civino (University of L’Aquila - Italy) </li>
    <li> Amit Chaudhary (University of Warwick - UK)</li>
    <li> Andrej Dujella (University of Zagreb - Croatia) </li>
    <li> Anna Lisa Ferrara (University of Molise - Italy) </li>
    <li> Hubert Le Van Gong (J.P. Morgan Chase & Co - USA) </li>
    <li> Tako Boris Fouotsa (EPFL - Switzerland) </li>
    <li> Danilo Francati (Aarhus University - Denmark)</li>
    <li> Daniele Friolo ("Sapienza" University of Rome - Italy) </li>
    <li> Philippe Gaborit (University of Limoges - France) </li>
    <li> James Gomez (Banco Santander - Spain) </li>
    <li> Geoffrey Goodel (UCL Center for Blockchain Technologies - UK) </li>
    <li> Delaram Kahrobaei (New York University - USA) </li>
    <li> Elena Kirshanova (Technology Innovation Institute - UAE)</li>
    <li> Yashvanth Kondi (Silence Laboratories - Singapore) </li>
    <li> Lind Jeng (Digital Self Labs - USA) </li>
    <li> Gregor Leander (University Bochum - Germany) </li>
    <li> Nian Li (Hubei University - China) </li>
    <li> Sihem Mesnager (University of Paris VIII - France)</li>
    <li> Giacomo Micheli (University of South Florida - USA) </li>
    <li> Massimo Morini (USI Lugano - Switzerland)</li>
    <li> Matteo Nardelli (Banca d'Italia - Italy) </li>
    <li> Ludovic Perret (EPITA and Sorbonne University - France) </li>
    <li> Svetla Petkova-Nikova (KU Leuven - Belgium) </li>
    <li> Alberto Ravagnani (TU Eindhoven - Netherlands) </li>
    <li> Divya Ravi (University of Amsterdam - Netherlands)</li>
    <li> Simona Samardjiska (Radboud University - The Netherlands)</li>
    <li> Santanu Sarkar (Indian Institute of Technology Madras - India) </li>
    <li> Pantelimon Stanica (Naval Postgraduate School - USA) </li>
    <li> Serge Vaudenay (EPFL - Switzerland) </li>
    <li> Polina Vinogradova (IOHK - Canada)</li>
    <li> Hendrik Waldner (Nethermind Research - UK) </li>
  </ul>
</div>
<div class="toptext">
  <h2>Contacts</h2>
  <p>
    E-mail:
    <a href="mailto:fcir25@decifris.it">
      fcir25&#64;decifris.it
    </a>
  </p>
</div>